import { integerToMoney } from '@/app/lib/moneyHandler'
import { Button, Popover } from '@mui/material'
import cn from 'classnames'
import { ReactNode, useState } from 'react'
import { UseRangeProps } from 'react-instantsearch'
import { RangeSlider, useRangeRefinementStatus } from './RangeSlider'

type RefinementsMenuRangeProps = UseRangeProps & {
  label: ReactNode
  icon?: ReactNode
  formatLabel?: (value: number) => string | number
}

export function RefinementsMenuRange({
  label,
  icon,
  formatLabel = integerToMoney,
  ...rangeProps
}: RefinementsMenuRangeProps) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const { canRefine, hasValidRange, hasRefinedRange } =
    useRangeRefinementStatus(rangeProps)

  const buttonId = `refinement-range-${rangeProps.attribute.replace(/\./g, '-')}`
  const popoverId = `${buttonId}-popover`

  return (
    <>
      <Button
        id={buttonId}
        aria-controls={open ? popoverId : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        variant="outlined"
        disabled={!canRefine || !hasValidRange}
        startIcon={icon}
        className={cn(
          'border-divider-light',
          hasRefinedRange ? 'bg-lines/50' : ''
        )}
      >
        {label}
      </Button>
      <Popover
        id={popoverId}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <RangeSlider
          {...rangeProps}
          formatLabel={formatLabel}
          className="w-80 p-6"
        />
      </Popover>
    </>
  )
}
